import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-8 px-4 text-center text-sm" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <p className="mb-4" data-id="element-55">
          © 2026 @tiendadigitalonline – Megapack Alimentación Saludable. Todos
          los derechos reservados.
        </p>
        <div className="flex justify-center gap-4 font-medium" data-id="element-56">
          <a href="#" className="hover:text-white transition-colors" data-id="element-57">
            Privacidad
          </a>
          <span data-id="element-58">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-59">
            Términos y condiciones
          </a>
        </div>
        <p className="mt-8 text-xs text-gray-600" data-id="element-60">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}